export default "__VITE_ASSET__Bz_YLk4o__"